import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        "user",
        "isUserLoggedIn",
        "token",
        "game",
        "gamePacks"
      ]
    })
  ],
  strict: true,
  state: {
    user: null,
    isUserLoggedIn: false,
    token: null,
    gameId: null,
    game: {
      id: null,
      title: null,
      invite_code: null,
      activeInvestigators: [],
      graveyardInvestigators: [],
      game_pack_selection: [],
      reserve_cards: [],
      discarded_cards: []
    },
    gamePacks: []
  },
  getters: {
    userId: state => {
      if (state.user === null) {
        return null;
      }

      return state.user.id;
    },
    userName: state => {
      if (state.user === null) {
        return null;
      }

      return state.user.username;
    },
    gameId: state => {
      return state.gameId ?? null;
    },
    game: state => {
      return state.game;
    },
    gamePacks: state => {
      return state.gamePacks;
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setGameId(state, gameId) {
      state.gameId = gameId;
    },
    setGame(state, game) {
      state.game = game;
    },
    setGamePacks(state, gamePacks) {
      state.gamePacks = gamePacks;
    },
    setReserveSlots(state, reserveSlots) {
      state.game.reserve_slots = reserveSlots;
    }
  },
  actions: {
    setToken({commit}, token) {
      commit("setToken", token);
    },
    setUser({commit}, user) {
      commit("setUser", user);
    },
    clearUser({commit}) {
      commit("setToken", null);
      commit("setUser", null);
    },
    setGameId({commit}, gameId) {
      commit("setGameId", gameId);
    },
    setGame({commit}, game) {
      commit("setGame", game);
    },
    setGamePacks({commit}, gamePacks) {
      commit("setGamePacks", gamePacks);
    },
    setReserveSlots({commit}, reserveSlots) {
      commit("setReserveSlots", reserveSlots);
    }
  }
});
